import zIndex from "@mui/material/styles/zIndex";

export const useStyles = {
    form: {
        gap: '1',
        width: '100%',
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    login: {
        minWidth: "40vh",
        padding: "1rem",
        marginTop: "6rem"
    },
    passwd: {
        padding: "1rem",
        marginTop: "2rem",
        textAlign: "center",
        backgroundColor: 'palette.background.paper',
    },
    gridBottom: {
        marginBottom: '1rem'
    },
    inputLabel: {
        color: 'royalblue',
        paddingRight: '8px',
        marginBottom: '.4rem'
    },
    divider: {
        borderTop: '2px solid',
        borderTopColor: 'divider'
    },
    title: {
        color: 'sienna',
    },
    controlPanel: {
        padding: "1rem",
        marginTop: "1rem",
        textAlign: "left",
        backgroundColor: 'palette.background.paper',
    },
    formControl: {
        gap: '1',
    },
    formFields: {
        marginLeft: '1rem',
    },
    listContainer: {
        paddingLeft: '1rem',
        paddingRight: '1rem',
        fontSize: '1.2rem',
        backgroundColor: 'palette.background.paper',
    },
    list: {
        width: '100%',
        backgroundColor: 'palette.background.paper',
        padding: '0'
    },
    listPadding: {
        padding: '.3rem',
        overflow: 'hidden'
    },
    listText: {
        margin: '2px 0'
    },
    tableContainer: {
        maxHeight: '72vh',
    },
    tableCell: {
        padding: '0 1rem',
    },
    listDivider: {
        backgroundColor: 'slategrey'
    },
    inline: {
        display: 'inline',
    },
    margin: {
        gap: '1'
    },
    button: {
        margin: '8px'
    },
    squashedButton: {
        height: '2rem',
        marginTop: '0',
        margin: '.5rem'
    },
    tinyButton: {
        height: '1.6rem',
        fontSize: '.7rem'
    },
    checkbox: {
        margin: '0',
        transform: 'scale(.9)',
        height: '.9rem'
    },
    textbox: {
        height: '.2rem',
        paddingTop: '.9rem',
        paddingBottom: '.9rem'
    },
    numberbox: {
        height: '2.03rem',
    },
    backdrop: {
        zIndex: (theme) => zIndex.drawer + 1,
        color: '#fff',
    },
    label: {
        textAlign: 'right'
    },
    labelColor: {
        color: 'royalblue'
    },
    value: {
        textAlign: 'left'
    },
    valueRight: {
        fontSize: '.9rem',
        textAlign: 'right',
        paddingRight: '2rem'
    },
    dialog: {
        backgroundColor: 'transparent',
    },
    smallText: {
        fontSize: '.9rem',
    },
    menuText: {
        fontSize: '1rem',
        backgroundColor: "#fafafa#3f51b5",
        color: "#3f51b5"
    },
    menuTextDivider: {
        color: "#3f51b5",
        middle: 'true',
    },
    menuRoot: {
        flexGrow: 1,
        marginBottom: 15
    },
    menuButton: {
        marginRight: '16px',
    },
    menuTitle: {
        flexGrow: 1,
        textAlign: "right",
        marginTop: '.5rem',
        fontSize: "2rem",
        fontStyle: "italic",
        fontWeight: "bold"
    },
    visuallyHidden: {
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: 0,
        margin: '-1px',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: 0,
    }
};
